import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { CameraServerService } from '../../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { AppConstants, ErrorMessageFormField } from 'src/app/shared/app-constants';

@Component({
  selector: 'app-ec2-add-edit',
  templateUrl: './ec2-add-edit.component.html',
  styleUrls: ['./ec2-add-edit.component.scss'],
  standalone: false
})
export class Ec2AddEditComponent implements OnInit {

  newData: any = '';
  strobesInputForm: FormGroup = new FormGroup({});
  headerName: string = '';
  isAddButton: boolean = false;
  loading: boolean = false;
  isAddedData: boolean = false;
  isEditDevice: boolean = false;
  id: any;
  instanceId: string;
  nodeName: any = '';
  privateIp: any = '';
  publicIp: string = '';
  isEditable: boolean;
  add: any;
  userForm: FormGroup;
  errorMessageFormField: any =ErrorMessageFormField;

  displayedColumns: string[] = [
    'id',
    'nodeName',
    'instanceId',
    'privateIp',
    'publicIp',
    'action',
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();

  constructor(
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<Ec2AddEditComponent>,
    private camService: CameraServerService,
    private toaster: ToastrService,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    private formBuilder: FormBuilder
  ) {

    this.userForm = this.fb.group({
      nodeName: [''],
      instanceId: [''],
      privateIp: [''],
      publicIp: [''],

    });

    if (this.data.isEdit) {
      this.userForm.patchValue(this.data.edidatbleData);
    } else {
      this.userForm = this.fb.group({
        nodeName: [''],
        instanceId: [''],
        privateIp: [''],
        publicIp: [''],
      });
    }
  }

  ngOnInit(): void {

    this.userForm = this.formBuilder.group({
      nodeName: [this.userForm.value.nodeName, [Validators.required]],
      instanceId: [this.userForm.value.instanceId, [Validators.required]],
      privateIp: [this.userForm.value.privateIp, [Validators.required]],
      publicIp: [this.userForm.value.publicIp],

    });
    this.isEditable = this.data.isEdit;
    if (this.data.isEdit) {
      this.headerName = `Edit EC2 Farm - ${this.data?.edidatbleData?.nodeName}`
    } else {
      this.headerName = "Add EC2 Farm";
    }
  }

  get formControls() {
    return this.userForm.controls;
  }

  addFarm() {
    const requestPaylod: any = {
      instanceId: this.userForm.value.instanceId,
      nodeName: this.userForm.value.nodeName,
      privateIp: this.userForm.value.privateIp,
      publicIp: this.userForm.value.publicIp,
    };
    if (this.userForm.invalid) {
      return;
    } else {
      this.spinner.activate();
      this.camService.saveAllEc2(requestPaylod).subscribe((response) => {
        if (response && response.success) {
          this.spinner.deactivate();
          this.toaster.success("EC2 Farm Added Successfully..!");
          this.dialogRef.close(true);
        } else {
          this.spinner.deactivate();
          this.toaster.error(response?.messages[0] || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        if (err) {
          this.spinner.deactivate();
          this.toaster.error(AppConstants.defaultErrorMessage);
        }
      });
    }
  }

  updateForm() {
    const requestPayload = {
      nodeName: this.userForm.value.nodeName,
      instanceId: this.userForm.value.instanceId,
      privateIp: this.userForm.value.privateIp,
      publicIp: this.userForm.value.publicIp,
    };
    if (this.userForm.invalid) {
      return;
    } else {
      this.spinner.activate();
      this.camService.UpdateRecord(requestPayload).subscribe((res: any) => {
        if (res && res.success) {
          this.spinner.deactivate();
          this.toaster.success('Updated Successfully..!');
          this.dialogRef.close(true);
        } else {
          this.spinner.deactivate();
          this.toaster.error(res?.messages[0] || AppConstants.defaultErrorMessage);
        }
      }, (err) => {
        if (err) {
          this.spinner.deactivate();
          this.toaster.error(AppConstants.defaultErrorMessage);
        }
      });
    }
  }

}
